
<button matIconButton type="button" class="close" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<h4 mat-dialog-title class="box">{{ 'send-remark.title' | translate }}</h4>

<!-- *ngIf="!loading && !msgIsSent && !errorIsSent" -->
@if (!msgIsSent && !errorIsSent) {
<form [formGroup]="formGroup" (ngSubmit)="onSubmit(formGroup.value)" class="form">
  <mat-dialog-content class="mat-typography">
    <!-- {{ 'general.validation.alphabetic' | translate }} -->
    <mat-form-field appearance="outline" class="form-element">
      <mat-label>{{ 'general.form.firstname.placeholder' | translate }}</mat-label>
      <input type="txt" name="firstName" matInput formControlName="firstName">
      @if (!firstName.valid && firstName.touched) {
      <mat-error>
        {{'general.validation.maxlength'|translate}}
      </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="form-element">
      <mat-label>{{ 'general.form.lastname.placeholder' | translate }}</mat-label>
      <input type="txt" name="lastName" matInput formControlName="lastName">
      @if (!lastName.valid && lastName.touched) {
      <mat-error>
        {{'general.validation.maxlength'|translate}}
      </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="form-element">
      <mat-label>{{ 'general.form.email.placeholder' | translate }}</mat-label>
      <input type="email" name="email" matInput formControlName="email" value="pve@ngi.be">
      @if (!formGroup.controls['email'].valid && formGroup.controls['email'].touched) {
      <mat-error>
        {{ getErrorEmail() |translate}}
      </mat-error>
      }
    </mat-form-field>
    <!-- matAutosizeMinRows="2" matAutosizeMaxRows="15" -->
    <mat-form-field appearance="outline" class="form-element">
      <mat-label>{{ 'send-remark.form.message.placeholder' | translate }}</mat-label>
      <textarea cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="12" matInput value="iOS Test"
        formControlName="message"></textarea>
      @if (!formGroup.controls['message'].valid && formGroup.controls['message'].touched) {
      <mat-error>
        {{ getErrorMessage() | translate }}
      </mat-error>
      }
    </mat-form-field>
    <div class="copyright-txt">
      <a style="margin: 0 !important;" href="{{ 'general.terms_of_use_url' | translate }}" target="_blank">{{
        "general.terms_of_use" | translate }}</a>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="center" class="">
    <div class="button-container">
      <button mat-flat-button [disabled]="!formGroup.valid" type="submit">
        <mat-icon aria-label="map">send</mat-icon>&nbsp;&nbsp;{{"send-remark.button.send"|translate}}
        <span> &nbsp;@if (loading) {
          <mat-spinner style="float: right;margin-top:10px" color="accent" diameter=20></mat-spinner>
          }</span>
      </button>
    </div>
    <div class="button-container">
      <a matButton [mat-dialog-close]="[formGroup.value,formGroup.dirty]" mat-dialog-close
        class="close-tip">&nbsp;{{"general.close"|translate}}</a>
    </div>
  </mat-dialog-actions>
</form>
}



<!-- succes msg -->
@if (msgIsSent) {
<mat-dialog-content class="mat-typography">
  <br>
  <mat-icon style="color:#068a9b;display:contents">done</mat-icon>
  {{'send-remark.mail.sent'|translate}}
  <br>
  {{error}}
</mat-dialog-content>
}
@if (msgIsSent) {
<mat-dialog-actions align="center" class="">
  <div class="button-container">
    <a mat-button mat-dialog-close class="close-tip">&nbsp;{{"general.close"|translate}}</a>
  </div>
</mat-dialog-actions>
}



<!-- error msg -->
@if (errorIsSent) {
<mat-dialog-content class="mat-typography error-txt">
  <br>
  {{'send-remark.mail.error'|translate}}
  <br>
  {{error}}
</mat-dialog-content>
}
@if (errorIsSent) {
<mat-dialog-actions align="center" class="">
  <div class="button-container">
    <a mat-button mat-dialog-close class="close-tip">&nbsp;{{"general.close"|translate}}</a>
  </div>
</mat-dialog-actions>
}